import { Callout, Intent } from "@blueprintjs/core"
import { __ } from "../utilities"

/* Protopia Ecosystem component */
export interface ICalloutNoExistsProps {
   message?:string
   children?: JSX.Element
}
const CalloutNoExists = (props: ICalloutNoExistsProps): JSX.Element => {
    return <Callout intent={Intent.DANGER} className="p-5">
        { __(props.message ? props.message : "No elements exists") }
        { props.children }
    </Callout>
}
export default CalloutNoExists